import { useMutation } from '@tanstack/react-query'

import { deleteOnboardingRequest } from '@src/api'
import { DefaultApiDeleteOnboardingRequestRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useDeleteOnboardingRequest = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiDeleteOnboardingRequestRequest) =>
      deleteOnboardingRequest(axiosInstance, params),
  })
}
